(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const main = root.querySelector('[data-ws-main]');
    const thumbs = [...root.querySelectorAll('[data-ws-thumb]')];
    let current = 0;
    function show(index) {
      current = (index + thumbs.length) % thumbs.length;
      main.src = thumbs[current].dataset.full;
      main.alt = thumbs[current].dataset.alt;
      thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
    }
    thumbs.forEach((button, i) => button.addEventListener('click', () => show(i)));
    root.querySelectorAll('[data-ws-step]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.wsStep))));
    let start;
    main.addEventListener('touchstart', e => { start = { x: e.touches[0].clientX, y: e.touches[0].clientY }; }, {passive: true});
    main.addEventListener('touchend', e => {
      if (!start) return;
      const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      start = null;
    }, {passive: true});
    const notes = root.querySelector('[data-ws-notes]');
    root.querySelectorAll('[data-ws-note]').forEach(button => button.addEventListener('click', () => {
      notes.scrollTo({left: Number(button.dataset.wsNote) * (notes.clientWidth + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }));
    notes.addEventListener('scroll', () => { root.querySelector('[data-ws-note-count]').textContent = `${Math.round(notes.scrollLeft / (notes.clientWidth + 12)) + 1} / 2`; }, {passive: true});
  }
  document.querySelectorAll('[data-ws-preview]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-ws-preview]').forEach(init));
})();
